export default "__VITE_ASSET__CyAeTbor__"